import cache from '../util/cache'
import {
  toast
} from '../util/decorators'
import api from './api'
import BaseService from './BaseService'
const SETTING = 'SETTING'
const SEARCH = 'SEARCH'
const PRAYER = 'PRAYER'
const NEWS = 'NEWS'

export default class UserService extends BaseService {
  constructor() {
    super({
      current: {
        nickname: '未登录'
      }
    })
  }

  get current() {
    return this.data.current
  }

  set token(value) {
    if (!value) {
      value = window.localStorage.getItem('_utoken')
    }
    if (value) {
      this._token = value
      window.localStorage.setItem('_utoken', value)
    } else {
      if (window.isWechat) {
        this.goOauth()
      }
    }
  }

  async initialize(vue) {
    this.rootPath = vue.$route.fullPath
    console.info('launch', this.rootPath)
    await this.loadCurrent()
    this.setting = await api.user.getSetting()
    if (vue.$route.name == 'movie') {
      return
    }
    if (await this.checkUserState(vue, false, false, true)) {
      if (vue.$route.name == 'phone' || vue.$route.name == 'subscribe') {
        this.goReturn(vue)
        return
      }
    }
    if (this.settingCallback) {
      this.settingCallback()
      this.settingCallback = null
    }
  }

  async checkUserState(vue, force = false, tip = false, isFirst = false) {
    console.info('check wechat', window.isWechat)
    if (!window.isWechat) {
      if (isFirst) {
        return true
      }
      if (this._token) {

      } else {
        // console.info('--- go phone login')
        // this.rootPath = vue.$route.fullPath
        // vue.$router.push('/phone')
        window.location.href='https://www.fytvapp.com/wap/'
        return false
      }
    }
    console.info('check time', this.setting.h5_force_interval_time, force)
    if (this.setting.h5_force_interval_time && !force) {
      let now = Date.now()
      let last = window.localStorage.getItem('last_check')
      if (last && (Date.now() - last) / 3600000 < this.setting.h5_force_interval_time) {
        return true
      }
      window.localStorage.setItem('last_check', now)
    }
    console.info('check force mobile')
    if (this.setting.h5_force_mobile && !this.current.vmobile) {
      this.rootPath = vue.$route.fullPath
      console.info('--', this.rootPath)
      if (tip) {
        vue.$router.replace('/phone?tip=1')
      } else {
        vue.$router.replace('/phone')
      }
      return false
    }
    console.info('check force subscribe')
    if (this.setting.h5_force_subscribe) {
      let r = await api.user.getSubscribe(this._token, this.setting.h5_force_subscribe_appid, this.current.unionid)
      if (!r) {
        this.rootPath = vue.$route.fullPath
        console.info('--', this.rootPath)
        if (tip) {
          vue.$router.replace('/subscribe?tip=1')
        } else {
          vue.$router.replace('/subscribe')
        }
        return false
      }
    }
    return true
  }

  isSettingReady(callback) {
    if (this.setting) {
      callback()
    } else {
      this.settingCallback = callback
    }
  }

  goReturn(vue, ignore = false) {
    if (this.rootPath.indexOf('/phone') >= 0 || this.rootPath.indexOf('/subscribe') >= 0) {
      vue.$router.replace('/')
    } else {
      vue.$router.replace(this.rootPath)
    }
  }

  goOauth() {
    // let url = encodeURIComponent(`https://${window.location.host}/?token${window.location.hash}`)
    // window.location.replace(`https://users-api.sanmanuela.net/api/auth/webpage?appid=1&callback=${url}`)
  }

  @toast()
  async loadCurrent() {
    if (!this.current.userid && this._token) {
      try {
        this.data.current = await api.user.getCurrent(this._token)
      } catch (e) {
        return this.goOauth()
      }
    }
    return this.current
  }

  getSetting() {
    return parseInt(cache.load(SETTING, 0))
  }

  setSetting(value) {
    cache.save(SETTING, value)
  }

  isSubscribeOff() {
    return (this.getSetting() & 1) === 1
  }

  closeSubscribe() {
    this.setSetting(this.getSetting() | 1)
  }

  addFavourite(movie) {
    return api.user.addFav(this._token, 1, movie.movid)
  }

  getFavourites() {
    return api.user.getFavList(this._token)
  }

  isFavourite(movid) {
    return api.user.getFav(this._token, 1, movid)
  }

  removeFavourite(fid) {
    return api.user.delFav(this._token, fid)
  }

  addSearchHistory(value) {
    let history = this.getSearchHistory()
    let index = history.indexOf(value)
    if (index === 0) {
      return
    }
    if (index > 0) {
      history.splice(index, 1)
    }
    history.unshift(value)
    if (history.length > 10) {
      history.pop()
    }
    cache.save(SEARCH, history)
  }

  getSearchHistory() {
    return cache.load(SEARCH, [])
  }

  addNote(movid, urlid, title, subtitle, content) {
    return api.user.addNode(this._token, 1, movid, urlid, title, subtitle, content)
  }

  updateNode(id, title, subtitle, content) {
    return api.user.updateNode(this._token, id, title, subtitle, content)
  }

  getNote(tid, urlid) {
    return api.user.getNode(this._token, 1, tid, urlid)
  }

  getNotes() {
    return api.user.getNodeList(this._token)
  }

  removeNote(id) {
    return api.user.delNode(this._token, id)
  }

  getPlaybacks() {
    return api.user.getHistory(this._token, 1)
  }

  removePlayback(id) {
    return api.user.delHistory(this._token, id)
  }

  getPrayer() {
    return cache.load(PRAYER, 0)
  }

  readPrayer(time) {
    cache.save(PRAYER, time)
  }

  getLastNews() {
    return cache.load(NEWS, 0)
  }

  readLastNews(time) {
    cache.save(NEWS, time)
  }

  getPhoneCode(phone) {
    return api.user.getPhoneCode(phone)
  }

  async bindPhone(phone, code, itc) {
    await api.user.bindPhone(this._token, phone, code, itc)
    this.current.vmobile = 1
  }

  async loginByPhone(phone, code, itc) {
    let res = await api.user.loginByPhone(1, phone, code, itc)
    this.token = res.token
    await this.loadCurrent()
  }
}



// WEBPACK FOOTER //
// ./src/service/UserService.js